export default __webpack_public_path__ + "static/media/FoodChainDesert_08.ae2ec11e.png";